import "./metric-action.css";

/** The caller owns navigation, filters and permission checks. */
export type MetricActionProps = {
  href?: string;
  onSelect?: () => void;
  actionLabel?: string;
  /** Disabled metrics remain readable summaries, without a control or arrow. */
  disabled?: boolean;
};

export function isMetricActionable(action: MetricActionProps): boolean {
  return !action.disabled && Boolean(action.href || action.onSelect);
}

/** A native stretched control keeps a summary's dl/dt/dd structure intact. */
export function MetricAction({
  href,
  onSelect,
  actionLabel,
  disabled,
  label,
  descriptionId,
}: MetricActionProps & { label: string; descriptionId?: string }) {
  if (!isMetricActionable({ href, onSelect, disabled })) return null;
  const name = actionLabel || `${label} 자세히 보기`;
  if (href) {
    return (
      <a
        className="metric-action-control"
        href={href}
        aria-label={name}
        aria-describedby={descriptionId}
      />
    );
  }
  return (
    <button
      className="metric-action-control"
      type="button"
      onClick={onSelect}
      aria-label={name}
      aria-describedby={descriptionId}
    />
  );
}
